import React from "react";

export default function GapaVillage() {
  const handleBooking = (e) => {
    e.preventDefault();
    window.open("http://www.gapa.kr/web/page", "_blank", "noopener,noreferrer");
  };

  // 🌟 가파마을 주변 관광지 데이터 배열
  const attractions = [
    {
      name: "천장호 출렁다리",
      image:
        "https://www.telltrip.com/wp-content/uploads/2025/06/Cheongyang-Cheonjangho-Swinging-Bridge3.jpg",
      desc: "칠갑산 자락에 위치하여 거대한 용과 호랑이 조형물이 반겨주는 청양의 명물 출렁다리"
    },
    {
      name: "고운식물원",
      image:
        "https://lh4.googleusercontent.com/proxy/bKmGfgDC0zhq6jDCsAcLk_xBKtPvkb-cZtlmy4eUcF7u0puAjQ0DoiF-TSyxRRm_A5kCTTdZFsTkIlgAXca8uraxO4rXfg",
      desc: "다양한 희귀 식물과 감성적인 산책로가 조성되어 가족 여행에 최적화된 친환경 생태 가든"
    },
    {
      name: "칠갑산 장곡사",
      image: "https://cdn.e2news.com/news/photo/201010/44279_10162_1848.jpg",
      desc: "천년의 세월을 간직한 고찰로 귀중한 문화재들과 아늑한 산사 고유의 정취를 품은 곳"
    }
  ];

  return (
    <div style={styles.fcContainer}>
      {/* 1. 멀티 모자이크 갤러리 */}
      <div style={styles.galleryGrid}>
        <div style={styles.galleryTable}>
          <div style={styles.galleryMainCell}>
            <div
              style={{
                ...styles.imgPlaceholder,
                backgroundImage:
                  'linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.4)), url("https://tour.chungnam.go.kr/thumbnail/trsrcn/920_TRSRCN_202501060339029310.jpg")'
              }}
            >
              <div style={styles.verifiedBadge}>✨ 팜시티 인증</div>
              <div style={styles.imgOverlayText}>대표 전경</div>
            </div>
          </div>
          <div style={styles.gallerySubCell}>
            <div style={styles.subGridTable}>
              <div style={styles.subGridRow}>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://img.hankyung.com/photo/202406/AA.37035626.1.jpg")'
                    }}
                  />
                </div>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://img.hankyung.com/photo/202406/AA.37034728.3.jpg")'
                    }}
                  />
                </div>
              </div>
              <div style={styles.subGridRow}>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://mblogthumb-phinf.pstatic.net/MjAyNDAzMjZfMjkz/MDAxNzExNDQ2Mzc3OTA0.-2aYABfDRoufL4wDM8hp_r6ir1wSmbkxjfZQYwuzMLwg.VXp8upL_X3R_1ujJ0XI7GNGlpmLY2pCm5MNcik10pacg.JPEG/3W5A1380_(2).JPG?type=w800")'
                    }}
                  />
                </div>
                <div style={styles.subGridItem}>
                  <div
                    style={{
                      ...styles.imgPlaceholder,
                      backgroundImage:
                        'url("https://img.hankyung.com/photo/202406/AA.37033296.3.jpg")'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.mainLayoutWrapper}>
        <div style={styles.leftContentStream}>
          <div style={styles.farmTitleHeader}>
            <h1
              style={{
                fontSize: "32px",
                fontWeight: "800",
                color: "#1a202c",
                marginBottom: "8px"
              }}
            >
              가파마을
            </h1>
            <div
              style={{
                fontSize: "18px",
                color: "#718096",
                marginBottom: "12px"
              }}
            >
              Gapa Village
            </div>
            <div style={{ fontSize: "14px", color: "#4a5568" }}>
              📍 대한민국 충청남도 청양군 대치면 가파로 506-8
            </div>
          </div>

          <div style={styles.sectionTitleSub}>농장 한눈에 보기</div>
          <div style={styles.featuresBadgeCloud}>
            {[
              "🚜 농촌 활동 (Activities)",
              "🏡 가족 친화적 (Family-Friendly)",
              "🌾 전통 워크숍 (Workshop)",
              "🛌 농촌 숙박/펜션 (Farmstays)",
              "🍎 로컬 푸드 마켓 (Farm Market)",
              "✂️ 농산물 수확 (Pick Your Own)"
            ].map((tag, idx) => (
              <span key={idx} style={styles.fcBadge}>
                {tag}
              </span>
            ))}
          </div>

          <div style={{ marginBottom: "40px" }}>
            <h3
              style={{
                fontSize: "22px",
                fontWeight: "700",
                marginBottom: "16px"
              }}
            >
              여행 정보
            </h3>
            <div
              style={{
                fontSize: "16px",
                color: "#4a5568",
                textAlign: "justify"
              }}
            >
              <p style={{ marginBottom: "16px" }}>
                충남의 알프스라 불리는 아름다운 칠갑산 자락 아래, 청정 오지
                마을인 상갑리에 위치한 '가파마을'은 호리병 모양의 아늑한 분지
                지형을 가진 휴양 마을입니다. 예부터 '아름다운 언덕'이라는 뜻을
                지닌 가파(嘉波)라는 이름에 걸맞게, 수려한 천혜의 자연경관과 옛
                시골의 정취를 온전히 보존하고 있는 청양의 대표적인 웰빙 힐링
                명소입니다.
              </p>
              <p style={{ marginBottom: "16px" }}>
                가파마을은 농촌의 전통 문화와 먹거리를 직접 경험할 수 있는
                다채로운 체험 프로그램을 운영하고 있습니다. 청양의 대표 특산물인
                유기농 구기자를 활용한 소금·청 만들기와 가마솥 전통 두부 만들기,
                구기자 고추장 및 고추장떡 만들기 등 오감을 자극하는 전통 맛
                체험이 준비되어 있습니다. 또한, 천연 쪽염색과 대나무 헬리콥터
                만들기, 짚공예 등 선조들의 지혜가 담긴 전통 공예와 함께 숭경도,
                쌍육놀이와 같은 이색 전통 놀이를 통해 특별한 즐거움을
                선사합니다.
              </p>
              <p style={{ marginBottom: "16px" }}>
                마을 주변의 천장호 출렁다리와 장곡사, 안심사 템플스테이를 연계한
                당일 여정부터, 아늑한 마을 독채 펜션에서의 하룻밤과 고운식물원
                관람이 포함된 1박 2일 코스까지 준비되어 있어 대가족이나 단체
                여행객 모두가 편안하고 풍성한 농촌 체류형 관광(촌캉스)을 만끽할
                수 있습니다.
              </p>
            </div>
          </div>

          <div style={{ borderTop: "1px solid #edf2f7", paddingTop: "32px" }}>
            <div style={styles.sectionTitleSub}>농장 키포인트</div>
            <div style={{ marginBottom: "40px" }}>
              {[
                {
                  title: "🌶️ 가파마을의 자랑, 건강한 유기농 구기자&고추 체험",
                  body: "청양의 따뜻한 햇살을 받고 자란 유기농 구기자와 고추를 직접 수확하고, 이를 활용해 고추장과 구기자 소금 등 특별한 로컬 푸드를 만들어 가져갈 수 있습니다."
                },
                {
                  title: "🌿 자연의 푸른빛을 담아가는 천연 쪽염색",
                  body: "천연 염료를 이용해 나만의 섬유 제품을 물들이는 감성 워크숍입니다. 옷에 묻어도 안전한 친환경 체험으로, 아이들과 함께 참여하기에 아주 좋습니다."
                },
                {
                  title: "🎲 조선시대 선비들의 보드게임, 숭경도와 쌍육놀이",
                  body: "컴퓨터 게임에서 벗어나 옛 선비들이 즐기던 전통 놀이를 경험해 보세요. 룰이 쉽고 흥미진진하여 단체 워크숍이나 가족 대항전으로 인기가 높습니다."
                },
                {
                  title: "🏡 단체를 위한 아늑한 휴식처, 대형 독채 펜션",
                  body: "마을 내에 최대 40명까지 숙박이 가능한 독채 펜션 3개 동이 완비되어 있습니다. 단체 이용 시에는 밤하늘의 별을 보며 정을 나누는 완벽한 촌캉스 숙박이 가능합니다."
                },
                {
                  title: "📋 단체 및 맞춤형 코스는 사전 상담 필수",
                  body: "전통 두부 만들기나 사찰 연계 프로그램 등은 재료 준비 및 일정 조율이 필요하므로, 방문 전 반드시 예약 센터를 통해 인원과 코스를 확정해 주세요."
                }
              ].map((reminder, idx) => (
                <div key={idx} style={styles.reminderRowItem}>
                  <span style={styles.reminderCardHeader}>
                    {reminder.title}
                  </span>
                  <span style={styles.reminderCardBody}>{reminder.body}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 🌟 [신규 추가] 가파마을 주변 관광지 레이아웃 영역 */}
          <div
            style={{
              borderTop: "1px solid #edf2f7",
              paddingTop: "32px",
              marginBottom: "24px"
            }}
          >
            {" "}
            <h3
              style={{
                fontSize: "22px",
                fontWeight: "700",
                marginBottom: "20px"
              }}
            >
              주변 관광지
            </h3>
            <div style={styles.attractionsGrid}>
              {attractions.map((place, idx) => (
                <div key={idx} style={styles.attractionCard}>
                  <div
                    style={{
                      ...styles.attractionImg,
                      backgroundImage: `url("${place.image}")`
                    }}
                  />
                  <div style={styles.attractionInfo}>
                    <h4 style={styles.attractionName}>{place.name}</h4>
                    <p style={styles.attractionDesc}>{place.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={styles.rightSidebarStream}>
          <div style={styles.stickyInfoCard}>
            <div style={styles.sidebarWidgetTitle}>농장 기본정보</div>
            <div style={styles.essentialsRow}>
              <div style={styles.essentialsLabel}>주소 (Address)</div>
              <div style={styles.essentialsValue}>
                대한민국 충청남도 청양군 대치면 가파로 506-8
              </div>
            </div>
            <div style={styles.essentialsRow}>
              <div style={styles.essentialsLabel}>문의전화 (Phone)</div>
              <div style={styles.essentialsValue}>
                <a
                  href="tel:041-944-2401"
                  style={{
                    color: "#1a4331",
                    fontWeight: "700",
                    textDecoration: "underline"
                  }}
                >
                  041-944-2401
                </a>
                <span style={{ color: "#cbd5e0", margin: "0 6px" }}>|</span>
                <a
                  href="tel:010-7464-2401"
                  style={{
                    color: "#1a4331",
                    fontWeight: "700",
                    textDecoration: "underline"
                  }}
                >
                  010-7464-2401
                </a>
              </div>
            </div>
            <div style={styles.essentialsRow}>
              <div style={styles.essentialsLabel}>홈페이지 (Website)</div>
              <div style={styles.essentialsValue}>
                <a
                  href="http://www.gapa.kr/web/page"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1a4331",
                    textDecoration: "underline",
                    fontWeight: "600"
                  }}
                >
                  www.gapa.kr/web/page
                </a>
              </div>
            </div>
            <div
              style={{
                ...styles.essentialsRow,
                marginTop: "16px",
                borderTop: "1px solid #edf2f7",
                paddingTop: "12px"
              }}
            >
              <div style={styles.essentialsLabel}>
                산지 직송 살거리 (Market Items)
              </div>
              <div
                style={{
                  ...styles.essentialsValue,
                  fontSize: "14px",
                  color: "#4a5568",
                  lineHeight: "1.5"
                }}
              >
                유기농 구기자, 건고추 및 고추가루, 절임배추, 김장김치, 청양
                멜론, 표고버섯, 각종 잡곡류
              </div>
            </div>
            <div
              style={{
                ...styles.essentialsRow,
                marginTop: "16px",
                borderTop: "1px solid #edf2f7",
                paddingTop: "16px"
              }}
            >
              <div style={styles.essentialsLabel}>Hours (운영 시간)</div>
              <div style={{ ...styles.essentialsValue, fontWeight: "700" }}>
                월요일 ~ 일요일 (상시 운영)
              </div>
              <div
                style={{
                  color: "#1a4331",
                  fontSize: "16px",
                  fontWeight: "800",
                  marginTop: "2px"
                }}
              >
                09:00 AM - 06:00 PM
              </div>
            </div>
            <div style={styles.bookingStatusBox}>
              <div style={{ fontSize: "13px", color: "#166534" }}>
                <strong>✅ 실시간 예약 슬롯 활성화</strong>
                <br />
                해당 휴양마을은 FarmCiti 파트너십 채널이 완비되어 실시간 연동
                예약이 가능합니다.
              </div>
            </div>
            <button onClick={handleBooking} style={styles.fcPrimaryBtnActive}>
              실시간 예약하기 →
            </button>
          </div>

          <div style={{ ...styles.sidebarWidgetTitle, marginTop: "32px" }}>
            위치 및 날씨 정보
          </div>
          <div>
            <div style={styles.mapContainerBox}>
              <iframe
                title="Google Map Gapa Safe"
                src="https://maps.google.com/maps?q=%EC%B6%A9%EB%82%A8%20%EC%B2%AD%EC%96%91%EA%B5%B0%20%EB%8C%80%EC%B9%98%EB%A9%B4%20%EA%B0%80%ED%8C%8A%EB%A1%9C%20506-8%20%EA%B0%80%ED%8C%8A%EB%A1%9C%20506-8%20%EA%B0%80%ED%8C%8A%EB%A7%88%EC%9D%84&t=&z=15&ie=UTF8&iwloc=&output=embed"
                style={styles.mapIframeStyle}
                allowFullScreen=""
                loading="lazy"
              />
            </div>
            <div style={styles.weatherWidgetContainer}>
              <div style={styles.weatherMainRow}>
                <div style={styles.weatherIconAnim}>☀️</div>
                <div>
                  <div style={styles.weatherTempText}>18.5°C</div>
                  <div style={styles.weatherStatusText}>
                    실시간 기상: 맑음 (Clean Air)
                  </div>
                </div>
              </div>
              <div style={styles.weatherDetailGrid}>
                <div style={styles.weatherDetailItem}>
                  <span style={styles.weatherDetailLabel}>습도</span>
                  <span style={styles.weatherDetailValue}>45%</span>
                </div>
                <div style={styles.weatherDetailItem}>
                  <span style={styles.weatherDetailLabel}>풍속</span>
                  <span style={styles.weatherDetailValue}>2.1 m/s</span>
                </div>
                <div style={styles.weatherDetailItem}>
                  <span style={styles.weatherDetailLabel}>미세먼지</span>
                  <span
                    style={{ ...styles.weatherDetailValue, color: "#2FA322" }}
                  >
                    좋음 (15㎛)
                  </span>
                </div>
              </div>
              <div style={styles.weatherUpdateFooter}>
                청양군 기상대 실시간 동네예보 바인딩 완료
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  fcContainer: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "24px 40px",
    backgroundColor: "#fcfcf9"
  },
  galleryGrid: {
    display: "block",
    width: "100%",
    marginBottom: "32px",
    borderRadius: "16px",
    overflow: "hidden"
  },
  galleryTable: {
    display: "flex",
    width: "100%",
    minHeight: "60vh",
    gap: "8px"
  },
  galleryMainCell: { flex: 1 },
  gallerySubCell: { flex: 1 },
  subGridTable: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: "8px"
  },
  subGridRow: { display: "flex", flex: 1, gap: "8px" },
  subGridItem: { flex: 1 },
  imgPlaceholder: {
    width: "100%",
    height: "100%",
    backgroundColor: "#e2e8f0",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    minHeight: "210px",
    borderRadius: "8px"
  },
  verifiedBadge: {
    position: "absolute",
    top: "16px",
    left: "16px",
    backgroundColor: "#1a4331",
    color: "#ffffff",
    padding: "6px 14px",
    fontSize: "12px",
    fontWeight: "700",
    borderRadius: "30px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    zIndex: 3
  },
  imgOverlayText: {
    position: "absolute",
    bottom: "16px",
    left: "16px",
    background: "rgba(0, 0, 0, 0.6)",
    color: "#ffffff",
    padding: "6px 12px",
    fontSize: "12px",
    borderRadius: "4px"
  },
  mainLayoutWrapper: {
    display: "flex",
    width: "100%",
    gap: "48px",
    marginTop: "20px"
  },
  leftContentStream: { flex: 1.8 },
  rightSidebarStream: { flex: 1, minWidth: "320px" },
  farmTitleHeader: {
    marginBottom: "24px",
    borderBottom: "1px solid #2FA322",
    paddingBottom: "24px"
  },
  sectionTitleSub: {
    fontSize: "16px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "#718096",
    marginBottom: "16px",
    fontWeight: "700"
  },
  featuresBadgeCloud: { display: "block", marginBottom: "36px" },
  fcBadge: {
    display: "inline-block",
    backgroundColor: "#f0fdf4",
    color: "#166534",
    padding: "8px 16px",
    borderRadius: "30px",
    fontSize: "14px",
    fontWeight: "600",
    marginRight: "8px",
    marginBottom: "8px",
    border: "1px solid #bbf7d0"
  },
  reminderRowItem: {
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "16px",
    display: "flex",
    flexDirection: "column"
  },
  reminderCardHeader: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#1a4331",
    marginBottom: "8px"
  },
  reminderCardBody: { fontSize: "14px", color: "#4a5568" },
  stickyInfoCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "16px",
    padding: "28px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)"
  },
  sidebarWidgetTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1a202c",
    marginBottom: "20px",
    borderBottom: "2px solid #1a4331",
    paddingBottom: "8px"
  },
  essentialsRow: { marginBottom: "16px" },
  essentialsLabel: {
    fontSize: "12px",
    fontWeight: "400",
    color: "#a0aec0",
    textTransform: "uppercase",
    marginBottom: "4px"
  },
  essentialsValue: { fontSize: "15px", color: "#2d3748", fontWeight: "500" },
  bookingStatusBox: {
    backgroundColor: "#f0fdf4",
    borderRadius: "8px",
    padding: "16px",
    marginTop: "20px",
    borderLeft: "4px solid #166534"
  },
  fcPrimaryBtnActive: {
    display: "block",
    width: "100%",
    backgroundColor: "#1a4331",
    color: "#ffffff",
    border: "none",
    padding: "14px",
    borderRadius: "8px",
    fontWeight: "700",
    fontSize: "16px",
    marginTop: "16px",
    cursor: "pointer",
    textAlign: "center"
  },
  pluginBox: {
    backgroundColor: "#edf2f7",
    border: "1px dashed #cbd5e0",
    borderRadius: "12px",
    padding: "24px",
    textAlign: "center",
    color: "#718096",
    fontSize: "13px",
    marginBottom: "16px"
  },
  mapContainerBox: {
    width: "100%",
    height: "240px",
    borderRadius: "12px",
    overflow: "hidden",
    marginBottom: "16px",
    border: "1px solid #e2e8f0"
  },
  mapIframeStyle: { border: 0, width: "100%", height: "100%" },
  weatherWidgetContainer: {
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "20px",
    textAlign: "left",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.02)",
    marginBottom: "16px"
  },
  weatherMainRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "16px",
    borderBottom: "1px solid #f1f3f5",
    paddingBottom: "14px"
  },
  weatherIconAnim: {
    fontSize: "36px",
    lineHeight: "1"
  },
  weatherTempText: {
    fontSize: "24px",
    fontWeight: "800",
    color: "#1a202c",
    lineHeight: "1.2"
  },
  weatherStatusText: {
    fontSize: "13px",
    color: "#718096",
    fontWeight: "500",
    marginTop: "2px"
  },
  weatherDetailGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "10px",
    textAlign: "center"
  },
  weatherDetailItem: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f8f9fa",
    padding: "8px 4px",
    borderRadius: "6px"
  },
  weatherDetailLabel: {
    fontSize: "11px",
    color: "#a0aec0",
    fontWeight: "600",
    marginBottom: "2px"
  },
  weatherDetailValue: {
    fontSize: "13px",
    color: "#2d3748",
    fontWeight: "700"
  },
  weatherUpdateFooter: {
    fontSize: "10px",
    color: "#cbd5e0",
    textAlign: "right",
    marginTop: "12px",
    fontWeight: "500"
  },

  // 🌟 [신규 추가] 주변 관광지 전용 스타일 규격
  attractionsGrid: {
    display: "flex",
    gap: "16px",
    width: "100%",
    boxSizing: "border-box"
  },
  attractionCard: {
    flex: 1,
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
    display: "flex",
    flexDirection: "column"
  },
  attractionImg: {
    width: "100%",
    height: "140px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor: "#e2e8f0"
  },
  attractionInfo: {
    padding: "12px"
  },
  attractionName: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#1a202c",
    marginBottom: "4px"
  },
  attractionDesc: {
    fontSize: "12px",
    color: "#718096",
    lineHeight: "1.4",
    margin: 0
  }
};
